import Image from 'next/image';
import Features from '@components/Features';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { CDN2 } from '@/helpers/api';
import DownloadApp from '@/components/DownloadApp';
import {
  QrcodeOutlined,
  EditOutlined,
  DollarOutlined,
} from '@/components/Icons';
import ButtonStore from '@/components/ButtonStore';
import { GetServerSideProps } from 'next';
import { basicPageProps, mobileProps } from '@/utils/isServer';

const ContentHeader = dynamic(() => import('@components/ContentHeader'), {
  loading: () => <p>Loading</p>,
});

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { isMobile, isIos } = mobileProps(ctx);
  const { airports, configInfo } = await basicPageProps(ctx);
  if (isMobile && isIos && ctx.query['redir'] == '1') {
    return {
      redirect: {
        destination: 'https://apps.apple.com/us/app/onairparking/id6444409018',
      },
    } as any;
  }

  if (isMobile && !isIos && ctx.query['redir'] == '1') {
    return {
      redirect: {
        destination:
          'https://play.google.com/store/apps/details?id=io.noson.onairparking&pli=1',
      },
    } as any;
  }
  return {
    props: {
      airports,
      mobileFeeDiscount: configInfo.mobileFeeDiscount || null,
    },
  };
};

function GetApp({ mobileFeeDiscount }) {
  return (
    <>
      <Head>
        <title>Get On Air Parking App | On Air Parking</title>
        <meta
          name="description"
          content="We exclusively choose only the best airport parking providers, shuttle service to and from the airport and a guaranteed parking space. Our Parking Reservation Specialist is at your service from 10am-7pm  ET."
        />
      </Head>
      <ContentHeader btitle="Download our App" />
      <div className="container mx-auto px-4">
        <div className="container px-4 mx-auto max-w-3xl">
          <div className="grid md:grid-cols-3 gap-8 py-8">
            <div className="flex flex-col items-center">
              <QrcodeOutlined className="text-primary font-bold text-5xl" />
              <strong className="text-base">Reservation Code</strong>
              <p className="text-sm">
                Easy access to your reservation and all details.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <DollarOutlined className="text-primary font-bold text-5xl" />
              <strong className="text-base">Multiple Payment Methods</strong>
              <p className="text-sm">
                Flexibility to choose credit/debit cards or digital wallets
              </p>
            </div>
            <div className="flex flex-col items-center">
              <EditOutlined className="text-primary font-bold text-5xl" />

              <strong className="text-base">Edit Reservations</strong>
              <p className="text-sm">
                Modify bookings with ease when your plans change
              </p>
            </div>
          </div>
        </div>
      </div>
      <DownloadApp mobileFeeDiscount={mobileFeeDiscount} />
    </>
  );
}

export default GetApp;
